import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SessionProvider } from './context/SessionContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PermissionProvider } from "./context/PermissionContext";
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import BusinessManager from './components/business/BusinessManager';
import Dashboard from './components/dashboard/Dashboard';
import Transaction from './components/transaction/Transaction';
import ProtectedRoute from './components/common/ProtectedRoute';
import PermissionRoute from './components/common/PermissionRoute';
import Loader from './components/common/Loader';
import Signup from './components/auth/Signup';
import { PERMISSIONS } from './api/permissions';

function AppContent() {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return <Loader message="Loading..." size="large" fullScreen />;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated || user ? <Navigate to="/business" replace /> : <Login />
          }
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/signup/:token" element={<Signup />} />
        <Route
          path="/business"
          element={
            <ProtectedRoute>
              <BusinessManager />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <PermissionRoute permission={PERMISSIONS.TRANSACTION_GET_SUMMARY_RESELLER}>
                <Dashboard />
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/transaction"
          element={
            <ProtectedRoute>
              <PermissionRoute permission={PERMISSIONS.TRANSACTION_GET_RESELLER}>
                <Transaction />
              </PermissionRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={<Navigate to={isAuthenticated || user ? '/business' : '/login'} replace />}
        />
        <Route
          path="*"
          element={<Navigate to={isAuthenticated || user ? '/business' : '/login'} replace />}
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <SessionProvider>
      <AuthProvider>
        <PermissionProvider>
          <AppContent />
        </PermissionProvider>
      </AuthProvider>
    </SessionProvider>
  );
}

export default App;